import React, {Component} from 'react';
import TableFilter from '../TableFilter'
import NewsTable from './NewsTable'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import {createInstance} from '../../Helpers';
import NewsStatoSelect from './NewsStatoSelect'
import PropTypes from 'prop-types';
import Moment from 'moment';
import StatoNewsComboFilter from "./StatoNewsComboFilter";

class NewsList extends Component {

    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = this.getDefaultState();

        this.storeInstance = createInstance();

        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.onChangeNewsStato = this.onChangeNewsStato.bind(this)
        this.loadData = this.loadData.bind(this)
        this.getStartPageByListViewType = this.getStartPageByListViewType.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
        this.onResettaFiltri = this.onResettaFiltri.bind(this)
        this.onDeleteNews = this.onDeleteNews.bind(this)
        this.onResetVisibility = this.onResetVisibility.bind(this)
        this.onResetVisibilityUser = this.onResetVisibilityUser.bind(this)
        this.onChangeStatoNewsFilter = this.onChangeStatoNewsFilter.bind(this)
    }

    getDefaultState(){
        return {
            items: [],
            total: 0,
            page: 1,
            orderInfo: {
                columnName: "dataAggiornamento",
                direction: "D",
                data: [
                    {
                        field: "dataAggiornamento",
                        direction: "D"
                    }
                ]
            },
            filterInfo: {
                keyword: '',
                visibile: true,
                statoNews: '0',
                statoNewsDesc: 'Tutte',

            },
            _loading: false,
            error: null,
            listViewType: 'l',
        };
    }

    getFilterDescription() {
        let msg = '';
        if (this.state.filterInfo.keyword !== undefined && this.state.filterInfo.keyword !== ''){
            msg += 'Titolo o testo contenente: ' + this.state.filterInfo.keyword;
        }
        if (this.state.filterInfo.visibile == false){
            msg += ' Notizie non visibili';
        }
        return  msg.trim();
    }

    onResettaFiltri(){
        this.setState(
            this.getDefaultState(),
            () => {this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);;}
        );
    }

    onChangeNewsStato(visibile){
        let newFilterInfo = {
            keyword: this.state.filterInfo.keyword,
            visibile
        };
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, newFilterInfo);
    }

    onChangeStatoNewsFilter(codice, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.statoNews = codice;
        filterInfo.statoNewsDesc = nome;
        this.loadData(1, this.state.orderInfo, filterInfo);
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('newslist', this, () => {
            // Stato reimpostato. Ricarica i dati
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        })) {
        } else {
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }
    }

    componentWillUnmount() {
        if (this.storeInstance) {
            this.storeInstance.save('newslist', this.state);
        }
    }

    getStartPageByListViewType(){
        return this.state.listViewType === 'l' ? 1 : -1;
    }

    onChangePage(newpage) {
        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onChangeColumnOrder(columnName, direction, data) {
        if (columnName){
            let newOrderInfo = {
                columnName: columnName,
                direction: direction,
                data: data
            };
            this.loadData(this.getStartPageByListViewType(), newOrderInfo, this.state.filterInfo)
        }
        else{
            this.loadData(this.getStartPageByListViewType(), {}, this.state.filterInfo);
        }
    }
    onChangeFilter(data){
        let newFilterInfo = this.state.filterInfo;
        newFilterInfo.keyword = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, newFilterInfo)
    }

    loadData(page, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadNewsList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo,
            client.getCurrentUserId()
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    onDeleteNews(ev, news){

        this.setState({_loading: true});
        client.deleteNews(news).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo)
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onResetVisibility(ev, news){

        this.setState({_loading: true});
        client.deleteNewsViewsByNews(news).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo)
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onResetVisibilityUser(ev, news){

        this.setState({_loading: true});
        client.updateNewsViewsByNewsAndUser(news.idNews, client.getCurrentUserId(), 1).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo)
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui three column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> News soddisfano i filtri specificati
                    </div>
                    <div className="column">
                        <div className="ui ">
                            <button className="ui  button" onClick={() => this.onResettaFiltri()}>
                                <i className="delete icon"></i>Reimposta i filtri</button>
                        </div>
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">

                        </div>
                    </div>
                </div>


            </h3>
            <div className="ui attached segment">
                <div className="ui two column stackable grid">
                    <div className="twelve wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.keyword}
                            placeholder="Filtra per titolo o testo"
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                    <div className="four wide column">
                        <StatoNewsComboFilter
                            statoNews={this.state.filterInfo.statoNews}
                            abilitato={true}
                            onChange={this.onChangeStatoNewsFilter}
                        />
                        
                    </div>
                </div>
            </div>

            <NewsTable
                items={this.state.items}
                count={this.state.total}
                page={this.state.page}
                rowperpage={this.rowperpage}
                tableOrderingField={this.state.orderInfo.columnName}
                tableOrderingDirection={this.state.orderInfo.direction}
                onChangePage={this.onChangePage}
                onChangeOrder={this.onChangeColumnOrder}
                onDeleteItem={this.onDeleteNews}
                onResetVisibility={this.onResetVisibility}
                onResetVisibilityUser={this.onResetVisibilityUser}
                filterDescription={this.getFilterDescription()}
                readOnly={client.getCurrentUser().isrolenewsw===false}
            />
            {loader}
        </div>)
    }
}

NewsList.contextTypes = {
    router: PropTypes.object
}


export default NewsList;




/** WEBPACK FOOTER **
 ** ./src/components/news/NewsList.js
 **/